<div class="kanban-board" [class.has-search-query]="hasSearchQuery()">
	<div class="kanban-columns" cdkDropListGroup>
		<div *ngFor="let column of filteredColumns | kanbanFilter: searchQuery" class="kanban-column"
			[style.min-width]="config.columnMinWidth">
			<div class="kanban-column-header">
				<div class="header-content">
					<div class="title-section">
						<h5 class="column-title">{{ column.title }}</h5>
						<span
							*ngIf="config.showCardCount"
							class="badge badge-pill badge-light column-count-badge"
							[ngbTooltip]="getColumnCountTooltip(column)"
							placement="bottom"
							triggers="mouseenter:mouseleave"
							container="body"
						>
							{{ getColumnCountLabel(column) }}
						</span>
						<!-- Info icon usage intentionally disabled -->
						<!-- <i class="info-icon feather icon-info"></i> -->
						<!-- Chevron icon usage intentionally disabled -->
						<!-- <i class="chevron-icon feather icon-chevron-down"></i> -->

						<ng-container *ngFor="let badge of column.badges">
							<!-- Scheduling badge intentionally hidden -->
							<span *ngIf="badge.id !== 'scheduling' && isBadgeVisible(badge, column)" [class]="badge.cssClass" [ngbTooltip]="badge.tooltip"
								[ngbPopover]="hasBadgePopover(badge) ? columnBadgePopover : null"
								[popoverContext]="{ data: getBadgePopoverData(badge) }" placement="bottom"
								triggers="mouseenter:mouseleave" container="body">
								<img *ngIf="badge.iconPath" [src]="badge.iconPath" alt="" class="badge-icon" />
								<i *ngIf="!badge.iconPath && badge.icon" class="feather icon-{{ badge.icon }}"></i>
							</span>
						</ng-container>
					</div>

					<div class="header-actions">
						<ng-container *ngFor="let button of getColumnButtons(column)">
							<button *ngIf="button.visible ? button.visible(column) : true" [class]="button.cssClass" type="button"
								(click)="onColumnButtonClick(button, column, $event)">
								<i *ngIf="button.icon" class="feather icon-{{ button.icon }}"></i>
								{{ button.label }}
							</button>
						</ng-container>

						<div *ngIf="hasActions(column)" ngbDropdown class="actions-dropdown" placement="bottom-end">
							<button class="btn btn-icon-only" type="button" ngbDropdownToggle (click)="$event.stopPropagation()">
								<i class="feather icon-more-vertical"></i>
							</button>
							<div ngbDropdownMenu class="dropdown-menu-end">
								<ng-container *ngFor="let action of column.actions">
									<button ngbDropdownItem type="button" (click)="onColumnAction(column, action, $event)">
										{{ getActionLabel(action) }}
									</button>
								</ng-container>
							</div>
						</div>
					</div>

					<ng-template #columnBadgePopover let-data="data">
						<div class="interview-stats-popover" *ngIf="data">
							<div class="stat-item">
								<i class="stat-icon feather icon-user"></i>
								<span class="stat-value">{{ data.total }}</span>
							</div>
							<div class="stat-item confirmed">
								<i class="stat-icon feather icon-check"></i>
								<span class="stat-value">{{ data.confirmed }}</span>
							</div>
							<div class="stat-item rejected">
								<i class="stat-icon feather icon-x"></i>
								<span class="stat-value">{{ data.rejected }}</span>
							</div>
						</div>
					</ng-template>
				</div>
			</div>

			<div class="kanban-cards" cdkDropList [id]="getColumnId(column)" [cdkDropListData]="column.cards"
				[cdkDropListDisabled]="!config.enableDragDrop" (cdkDropListDropped)="onCardDrop($event, column)">
				<div *ngFor="let card of column.cards; trackBy: trackByCardId" class="kanban-card"
					[class.moving]="movingCardId === card.id"
					[class.selectable]="selection.isCardCheckboxVisible(card, column)"
					[class.selected]="selection.isCardSelected(card)" cdkDrag
					[cdkDragDisabled]="!config.enableDragDrop || movingCardId === card.id || isCardDragDisabled(card) || processingBatch" (click)="onCardClick(card)">
					<label
						*ngIf="selection.isCardCheckboxVisible(card, column)"
						class="card-select-checkbox"
						[class.disabled]="selection.isCardSelectionDisabled(card, column)"
						(click)="$event.stopPropagation()"
						[ngbTooltip]="selection.getCardSelectionDenyReason(card, column)"
						[disableTooltip]="!selection.isCardSelectionDisabled(card, column)"
						placement="top"
						triggers="mouseenter:mouseleave"
						container="body"
					>
						<input
							type="checkbox"
							[checked]="selection.isCardSelected(card)"
							[disabled]="processingBatch || selection.isCardSelectionDisabled(card, column)"
							[attr.aria-label]="selection.getCardSelectionAriaLabel(card)"
							[attr.aria-describedby]="selection.getCardSelectionDescribedBy(card, column)"
							[attr.title]="selection.getCardSelectionDenyReason(card, column)"
							(change)="selection.onCardSelectionToggle(card, column, $event)"
						/>
					</label>
					<span
						*ngIf="selection.getVisibleSelectionDenyReason(card, column) as denyReason"
						class="sr-only"
						[id]="selection.getCardSelectionDenyElementId(card)"
					>{{ denyReason }}</span>
					<div class="card-content">
						<div class="card-loading-overlay" *ngIf="movingCardId === card.id">
							<div class="spinner-border spinner-border-sm text-primary" role="status">
								<span class="sr-only">Movendo...</span>
							</div>
						</div>
						<div class="card-main-content">
							<h6 class="card-title">{{ card.title }}</h6>
							<div class="card-icons">
								<ng-container *ngFor="let badge of card.badges">
									<button
										*ngIf="isBadgeVisible(badge, card) && badge.handler"
										type="button"
											[ngClass]="['document-button', badge.cssClass]"
										[ngbTooltip]="badge.tooltip"
										placement="bottom"
										triggers="mouseenter:mouseleave"
										container="body"
										(click)="onCardBadgeClick(badge, card, $event)"
										[disabled]="movingCardId === card.id"
									>
										<img *ngIf="badge.iconPath" [src]="badge.iconPath" alt="" class="badge-icon" />
									</button>
										<span
											*ngIf="isBadgeVisible(badge, card) && !badge.handler && badge.label"
											[ngClass]="['card-badge-label', badge.cssClass]"
											[ngbTooltip]="badge.tooltip"
											placement="bottom"
											triggers="mouseenter:mouseleave"
											container="body"
										>
											{{ badge.label }}
										</span>
									<img
											*ngIf="isBadgeVisible(badge, card) && !badge.handler && badge.iconPath && !badge.label"
										[src]="badge.iconPath"
										alt=""
											[ngClass]="['badge-icon', badge.cssClass]"
									/>
								</ng-container>
							</div>
						</div>
						<div
              class="card-menu"
              ngbDropdown
              container="body"
              *ngIf="movingCardId !== card.id && hasCardActions(card, column)"
              (click)="$event.stopPropagation()"
            >
              <button class="btn-menu" type="button" ngbDropdownToggle rippleEffect>
                <i class="menu-icon feather icon-more-vertical"></i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu-left card-dropdown-menu">
                <ng-container *ngFor="let action of card.actions">
                  <div *ngIf="isActionDivider(action)" class="dropdown-divider"></div>

                  <button
                    *ngIf="!isActionDivider(action) && isActionVisible(action, card)"
                    ngbDropdownItem
                    [class]="action.cssClass"
                    [class.disabled]="isActionDisabled(action, card)"
                    (click)="onCardActionClick(action, card, $event)"
                  >
                    <img
                      *ngIf="action.iconPath"
                      [src]="action.iconPath"
                      alt=""
                      class="action-icon"
                    />
                    <i *ngIf="!action.iconPath && (action.iconClass || action.icon)" [class]="action.iconClass || action.icon"></i>
					<span [ngClass]="action.labelClass">{{ action.label }}</span>
                  </button>
                </ng-container>
              </div>
            </div>
				</div>
			</div>

			<div *ngIf="column.cards.length === 0" class="empty-column">
				<p class="text-muted" *ngIf="!hasSearchQuery()">Nenhum card</p>
				<p class="text-muted" *ngIf="hasSearchQuery()">
					<i class="feather icon-search"></i><br />
					Nenhum resultado encontrado
				</p>
			</div>
		</div>
	</div>

	<div class="batch-action-bar" *ngIf="selection.activeSelectionColumn as column">
		<div class="batch-action-info">
			<span class="batch-selected-count">{{ selection.getVisibleSelectedCount(column) }} selecionados</span>
			<button
				type="button"
				class="batch-select-all"
				(click)="selection.onSelectAllInColumn(column)"
				[disabled]="processingBatch"
			>
				Selecionar todos da coluna ({{ selection.getSelectableCardCount(column) }})
			</button>
		</div>
		<div class="batch-action-buttons">
			<button
				type="button"
				class="btn btn-primary batch-move-btn"
				*ngFor="let action of selection.getBatchActions(column)"
				(click)="selection.onBatchAction(column, action)"
				[disabled]="processingBatch || action.disabled"
			>
				<span class="spinner-border spinner-border-sm mr-1" role="status" *ngIf="processingBatch"></span>
				{{ action.label }}
				<i [class]="action.iconClass" *ngIf="!processingBatch && action.iconClass"></i>
			</button>
			<button
				type="button"
				class="btn btn-light batch-cancel-btn"
				(click)="selection.onBatchCancel()"
				[disabled]="processingBatch"
			>
				Cancelar
			</button>
		</div>
	</div>
</div>
</div>